<script lang="ts">
import InfoWithTooltip from '@/presentation/components/InfoWithTooltip.vue';
import PromisePeriodChangedOnCell from '@/presentation/pages/resources/cells/PromisePeriodChangedOnCell.vue';

export default {
  name: 'StatusSinceColumn',
  components: { PromisePeriodChangedOnCell, InfoWithTooltip },
};
</script>

<template>
  <Column field="plant.status_since" sortable style="width: 10rem">
    <template #header>
      {{ $t('features.long_term.columns.status_since') }}

      <info-with-tooltip
        :title="$t('features.long_term.columns.status_since_tooltip')"
        class="ml-1"
      />
    </template>
    <template #body="slotProps">
      <promise-period-changed-on-cell
        :promise-periods="slotProps.data.plant.promise_statuses"
      />
    </template>
  </Column>
</template>

<style scoped></style>
